/**
 * Content registry — imports every unit/enemy JSON, validates it against its
 * zod schema once at module load, and exposes lookup maps keyed by id. This is
 * the single place the game (and World) reads content from; adding a unit or
 * enemy is "drop a JSON + add a line here".
 */
import { parseUnit, type Unit } from './schema/unit';
import { parseEnemy, type Enemy } from './schema/enemy';

import footmen from './units/footmen.json';
import archers from './units/archers.json';
import frostSpire from './units/frost_spire.json';
import mage from './units/mage.json';
import pilgrimWarden from './units/pilgrim_warden.json';

import shade from './enemies/shade.json';
import bronzeBrute from './enemies/bronze_brute.json';
import furySwarmling from './enemies/fury_swarmling.json';
import harpy from './enemies/harpy.json';
import unmadeRavager from './enemies/unmade_ravager.json';
import unmadeColossus from './enemies/unmade_colossus.json';
import bronzeMyrmidon from './enemies/bronze_myrmidon.json';
import bronzeShard from './enemies/bronze_shard.json';
import talosSentinel from './enemies/talos_sentinel.json';
import moltenMyrmidon from './enemies/molten_myrmidon.json';
import gildedEagle from './enemies/gilded_eagle.json';
import forgeWarden from './enemies/forge_warden.json';

function indexBy<T extends { id: string }>(items: T[]): Map<string, T> {
  return new Map(items.map((it) => [it.id, it]));
}

export const UNITS: Map<string, Unit> = indexBy(
  [footmen, archers, frostSpire, mage, pilgrimWarden].map(parseUnit),
);

export const ENEMIES: Map<string, Enemy> = indexBy(
  [
    shade,
    bronzeBrute,
    furySwarmling,
    harpy,
    unmadeRavager,
    unmadeColossus,
    bronzeMyrmidon,
    bronzeShard,
    talosSentinel,
    moltenMyrmidon,
    gildedEagle,
    forgeWarden,
  ].map(parseEnemy),
);
